module.exports = __webpack_public_path__ + "images/518eb0fa3148bfc9992d0ec1fcbd3035.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations04.jpg
// module id = ./webpack/assets/img/wheels-locations04.jpg
// module chunks = 0